import React from 'react'
import HeaderNavbar from '../Components/BybMainPage/BybNavbar/HeaderNavbar'


const ComingSoon = () => {
  return (
    <>

    <HeaderNavbar/>
    
    <div className='soon_wrapper'>
    <div className='coming_soon'>Still Brewing! Stay Tuned...</div>
    </div>
    </>
  )
}

export default ComingSoon